const spacing = (factor) => `${factor * 5}px`; // helper function

export const theme = {
  borders: {
    main: '1px solid #C2C9D1'
  },
  borderRadius: {
    main: '5px'
  },
  backgrounds: {
    pure: '#ffffff',
    offPure: '#fdfdfd',
    dark: '#000000',
    main: '#f5f5f5',
    primary: '#0280c6',
    lightPrimary: '#25aae3',
    offPrimary: '#f3fbff',
    secondary: '#F88700',
    lightSecondary: '#e8a14a',
  },
  boxShadow: {
    main: '1px 2px 2px #DDDDDD, 0px 4px 12px rgba(211, 211, 211, 0.45)'
  },
  colors: {
    text: '#565656',
    lightText: '#7e7e7e',
    primary: 'hsl(201, 98%, 39%)',
    lightPrimary: 'hsl(198, 77%, 52%)',
    secondary: '#F88700',
    lightSecondary: '#e8a14a',
  },
  fontSizes: {
    small: '13px',
    normal: '16px',
    large: '18px',
  },
  spacing,
  paddings: {
    small: spacing(1),
    normal: spacing(2),
    normalExtra: spacing(3),
    large: spacing(4),
  },
};